export default "https://legacy.eskolare-development.com/images/sellers-feature-four.png";